import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Input, Modal, Radio } from "antd";
import AddForm from "./addForm";
import styles from './index.module.less'

const CreateAddFormModal = ({ open, onCreate, onCancel, initialValues }) => {
  const [formInstance, setFormInstance] = useState();
  return (
    <Modal
      className="addModal"
      open={open}
      title="添加软件"
      okText="创建软件"
      cancelText="取消"
      okButtonProps={{ autoFocus: true }}
      onCancel={onCancel}
      destroyOnClose
      onOk={async () => {
        try {
          const values = await formInstance?.validateFields();
          formInstance?.resetFields();
          onCreate(values);
        } catch (error) {
          console.log("Failed:", error);
        }
      }}
    >
      <AddForm
        initialValues={initialValues}
        onFormInstanceReady={(instance) => {
          setFormInstance(instance);
        }}
      />
    </Modal>
  );
};

export default CreateAddFormModal;
